import * as requestsApi from "../network/apis/requests";

export const getRequestsListByPortal = (portal) =>
  portal === "company"
    ? requestsApi.getCompanyPortalRequestsList
    : requestsApi.getRequestsList;
